import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import type { ReleaseGroupState } from '../../../hooks/useReleaseGroupState';

import ReleaseGroupsSaveCancelButtons from './ReleaseGroupsSaveCancelButtons';

import styles from '../../ReleaseGroupsRevamp.module.less';

type Props = {
  pageTitle: string;
  saveButtonText: string;
  cancelButtonText?: string;
  validationErrors: ReturnType<ReleaseGroupState['validate']>;
  isLoading?: boolean;
  onCancel: () => void;
  onSave: () => void;
};

const ReleaseGroupsHeader: VoidFunctionComponent<Props> = (props) => {
  return (
    <div className={cx(styles.section, styles.header)}>
      <div className={styles.title}>
        {props.pageTitle}
      </div>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ReleaseGroupsSaveCancelButtons {...props} />
    </div>
  );
};

export default ReleaseGroupsHeader;
